import type { SVGProps } from "react";
const IcoChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.99974 7.16676C5.45997 7.16676 5.83307 7.53986 5.83307 8.0001C5.83304 8.46031 5.45996 8.83343 4.99974 8.83343C4.53959 8.83334 4.16643 8.46026 4.1664 8.0001C4.1664 7.53991 4.53957 7.16685 4.99974 7.16676Z"
      fill="white"
    />
    <path
      d="M7.99974 7.16676C8.45997 7.16676 8.83307 7.53986 8.83307 8.0001C8.83304 8.46031 8.45996 8.83343 7.99974 8.83343C7.53959 8.83334 7.16643 8.46026 7.1664 8.0001C7.1664 7.53991 7.53957 7.16685 7.99974 7.16676Z"
      fill="white"
    />
    <path
      d="M10.9997 7.16676C11.46 7.16676 11.8331 7.53986 11.8331 8.0001C11.833 8.46031 11.46 8.83343 10.9997 8.83343C10.5396 8.83334 10.1664 8.46026 10.1664 8.0001C10.1664 7.53991 10.5396 7.16685 10.9997 7.16676Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.4457 1.84189C6.80124 1.27974 8.30477 1.18077 9.72239 1.55999C11.14 1.93935 12.3937 2.77621 13.2875 3.9402C14.1811 5.10426 14.6654 6.53129 14.6658 7.99879C14.6661 9.0997 14.3938 10.1834 13.8734 11.1531L14.6417 13.8425C14.6739 13.9554 14.6748 14.0755 14.6443 14.1889C14.6136 14.3023 14.552 14.4051 14.4672 14.4864C14.3822 14.5678 14.2766 14.6241 14.1618 14.6498C14.0471 14.6756 13.9277 14.6701 13.8161 14.6329L11.2979 13.7924C10.0362 14.5109 8.57425 14.7987 7.13385 14.6101C5.67878 14.4195 4.32715 13.7539 3.2888 12.7169C2.25055 11.6798 1.58343 10.3286 1.39101 8.87379C1.19879 7.41902 1.49134 5.94059 2.22435 4.66937C2.95752 3.39816 4.09022 2.4041 5.4457 1.84189ZM7.99974 2.62379C7.16641 2.62402 6.34416 2.81775 5.59869 3.1902C4.85309 3.56282 4.20344 4.10443 3.70286 4.77093C3.20244 5.43736 2.86396 6.21155 2.71393 7.03135C2.56395 7.85117 2.6069 8.69507 2.83893 9.49554C3.07107 10.296 3.48654 11.0322 4.05182 11.6446C4.61715 12.257 5.3174 12.7295 6.09674 13.0248C6.87622 13.3202 7.71406 13.4305 8.54336 13.3464C9.37258 13.2623 10.1711 12.9862 10.8754 12.5405C10.9563 12.4892 11.0479 12.4564 11.143 12.4448C11.238 12.4332 11.3347 12.4431 11.4255 12.4734L13.0629 13.0183L12.557 11.2501C12.5327 11.1657 12.5265 11.0768 12.5375 10.9897C12.5458 10.9243 12.5634 10.8599 12.5909 10.8002L12.6221 10.7423C13.1063 9.92638 13.3654 8.99636 13.3741 8.04762C13.3826 7.09878 13.1398 6.16388 12.6703 5.33929C12.2008 4.51479 11.5212 3.82853 10.7009 3.35166C9.88066 2.87495 8.94845 2.62376 7.99974 2.62379Z"
      fill="white"
    />
  </svg>
);
export default IcoChat;
